function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

/*! jQuery Validation Plugin - v1.19.3 - 1/9/2021
 * https://jqueryvalidation.org/
 * Copyright (c) 2021 Jörn Zaefferer; Licensed MIT */
!function (a) {
  "function" == typeof define && define.amd ? define(["jquery", "../jquery.validate.min"], a) : "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) && module.exports ? module.exports = a(require("jquery")) : a(jQuery);
}(function (a) {
  return a.extend(a.validator.messages, {
    required: "Kötelező megadni.",
    maxlength: a.validator.format("Legfeljebb {0} karakter hosszú legyen."),
    minlength: a.validator.format("Legalább {0} karakter hosszú legyen."),
    rangelength: a.validator.format("Legalább {0} és legfeljebb {1} karakter hosszú legyen."),
    email: "Érvényes e-mail címnek kell lennie.",
    url: "Érvényes URL-nek kell lennie.",
    date: "Dátumnak kell lennie.",
    number: "Számnak kell lennie.",
    digits: "Csak számjegyek lehetnek.",
    equalTo: "Meg kell egyeznie a két értéknek.",
    range: a.validator.format("{0} és {1} közé kell esnie."),
    max: a.validator.format("Nem lehet nagyobb, mint {0}."),
    min: a.validator.format("Nem lehet kisebb, mint {0}."),
    creditcard: "Érvényes hitelkártyaszámnak kell lennie.",
    remote: "Kérem javítsa ki ezt a mezőt.",
    dateISO: "Kérem írjon be egy érvényes dátumot (ISO).",
    step: a.validator.format("A {0} egyik többszörösét adja meg.")
  }), a;
});